import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { trackIntegrationEvent } from '@modules/integrationsV2/utils';
import { Box, Drawer } from '@mui/material';
import { AddNewIntegrationDrawerContent } from './AddNewIntegrationDrawerContent';
import { AddNewIntegrationDrawerHeader } from './AddNewIntegrationDrawerHeader';

export const AddNewIntegrationDrawer = () => {
  const isDrawerOpen = useIntegrationsStore(({ view }) => view.isAddDrawerOpen);
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);

  const onCloseAddIntegrationDrawer = () => {
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        isAddDrawerOpen: false,
      },
    });
    trackIntegrationEvent({ eventName: 'Add New Integration Sidebar Closed' });
  };

  return (
    <Drawer
      open={isDrawerOpen}
      anchor="right"
      onClose={onCloseAddIntegrationDrawer}
    >
      <Box width="60vw">
        <AddNewIntegrationDrawerHeader />
        <AddNewIntegrationDrawerContent />
      </Box>
    </Drawer>
  );
};
